import { ca } from '@cian/analytics';

export function trackContactListOpen(newbuildingId: number, gaLabel: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Open_contacts_chats',
    action: 'CardJK',
    label: gaLabel,
    products: [
      {
        id: newbuildingId,
        offerType: 'JK',
      },
    ],
    page: {
      extra: {
        type: 'Open_jk_card',
      },
    },
  });
}
